import { Outlet, useLoaderData, useSubmit } from "react-router-dom";
import { useEffect } from 'react';
import { getTokenDuration } from "../util/auth";
function RootLayout() {
  const token = useLoaderData();
  const submit = useSubmit();
  // const navigation = useNavigation();
  useEffect(() => {
    if (!token) {
      return;
    }

    if (token === 'EXPIRED') {
      submit(null, { action: '/logout', method: 'post' });
      return;
    }

    const tokenDuration = getTokenDuration();

    const timer = setTimeout(() => {
      submit(null, { action: '/logout', method: 'post' });
    }, tokenDuration);

    return () => clearTimeout(timer);
  }, [token, submit]);
  return (
    <>
      <Outlet />
    </>
  );
}

export default RootLayout;
